export default __webpack_public_path__ + "static/media/APP_IONIC.60500d72.png";